<template>
  <div class="clasDelBlock">
    <Modal v-model="modal" width="360" footer-hide :styles="{top: '20%'}" class="error-modal">
      <div style="text-align:center">
        <img src="~assets/img/onlineblock/attentionmulticolor.png" alt />
        <p>确定要删除该机构吗？</p>
        <div class="btngroup">
          <Button class="btn" type="default" @click="modal = false">取消</Button>
          <Button class="btn" type="error" @click="deleteConfirm">确认</Button>
        </div>
      </div>
    </Modal>
    <Modal v-model="delsucess" width="360" footer-hide :styles="{top: '20%'}" class="error-modal">
      <div style="text-align:center" class="delSucess">
        <img src="~assets/img/public/successmulticolorBig.png" alt />
        <p>删除成功</p>
        <div class="btngroup">
          <Button class="btn" type="default" @click="delsucess = false">关闭</Button>
        </div>
      </div>
    </Modal>
    <Modal v-model="delfair" width="360" footer-hide :styles="{top: '20%'}" class="error-modal">
      <div style="text-align:center" class="delSucess">
        <img src="~assets/img/onlineblock/attentionmulticolor.png" alt />
        <p>{{resMsg}}</p>
        <div class="btngroup">
          <Button class="btn" type="default" @click="delfair = false">关闭</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: "ModalStructureDelete",
  props: {
    deleteStructureStatus: {
      type: Boolean,
      required: true
    },
    depa: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      delsucess: false,
      qkmsg: [],
      resMsg: '',
      delfair: false
    }
  },
  computed: {
    ...mapGetters(["username"]),
    modal: {
      get () {
        return this.deleteStructureStatus
      },
      set (val) {
        this.$emit("update:depa", '')
        this.$emit("update:deleteStructureStatus", val)
      }
    }
  },
  methods: {
    ///刪除分類
    deleteConfirm () {
      this.$axios
        .deldepa({ maid: this.username.maid, depaid: this.depa.depaid })
        .then(res => {
          if (res.status == 1) {
            this.$emit("getDepartment")
            this.$emit("getMalistData")
            this.delsucess = true
          }
          if (res.status == 0) {
            this.delfair = true
            this.resMsg = res.msg
          }
        })
        .catch(err => console.error(err))
      this.modal = false
    },
  }




}
</script>
<style lang="less">
.clasDelBlock {
  .error-modal.ivu-modal-body .btngroup .btn {
    border: none;
  }
}
</style>